import { useEffect, useState } from "react";

import { Input } from "@newsela/angelou";
import { IReturnArticleContributors } from "../../CitationAction.interface";
import {
  formBlockCss,
  inputCss,
  subTitleCss,
} from "./CitationEditFormArticle.style";

interface CitationEditFormArticleProps {
  title: string;
  touched: boolean;
  handleArticleReturn: (data: IReturnArticleContributors) => void;
}

const CitationEditFormArticle = ({
  title,
  touched,
  handleArticleReturn,
}: CitationEditFormArticleProps) => {
  const [titleValue, setTitleValue] = useState<string>(title);

  useEffect(() => {
    handleArticleReturn({ title: titleValue });
  }, [titleValue]);

  return (
    <div css={formBlockCss}>
      <h4 css={subTitleCss}>Article</h4>
      <Input
        label="Title"
        isRequired
        inputType={Input.inputTypes.text}
        underInputId="article-title"
        value={titleValue || ""}
        onChange={(e) => setTitleValue(e.target.value)}
        touched={touched}
        error={titleValue.length === 0 ? "Missing title" : null}
        __cssFor={inputCss}
      />
    </div>
  );
};

export default CitationEditFormArticle;
